/** Selection of all relation content fields for common relation contents */

import { ShortVideoValues, SmartLinkValues, VideoValues } from "./types";

export const videoFields: (keyof VideoValues)[] = [
  "internalDes",
  "title",
  "videoThumbnail",
  "description",
  "videoURL",
  "autoPlay",
  "mute",
  "loop",
  "noControl",
  "darkBackground",
  "displayInFourByThreeRatio",
];

export const shortVideoFields: (keyof ShortVideoValues)[] = [
  "internalDes",
  "title",
  "description",
  "videoThumbnail1",
  "videoThumbnail2",
  "videoThumbnail3",
  "shortVideo1",
  "autoPlay1",
  "mute1",
  "loop1",
  "noControl1",
  "darkBackground1",
  "shortVideo2",
  "autoPlay2",
  "mute2",
  "loop2",
  "noControl2",
  "darkBackground2",
  "shortVideo3",
  "autoPlay3",
  "mute3",
  "loop3",
  "noControl3",
  "darkBackground3",
];

export const smartLinksFields: (keyof SmartLinkValues)[] = [
  "name",
  "linkTitle",
  "icon",
  "newWindow",
  "relation",
  "externalUrl",
  "embedded",
];
